export default __webpack_public_path__ + "static/media/certificateLarge.8991c10b.webp";